<template>

<div id="charts-component">

	<top-bar></top-bar>

	<div class="row">
		<div class="col-sm-3">
			<tables-list :useCart="true"></tables-list>
		</div>
		<div class="col-sm-9">
			<tab></tab>
		</div>
	</div>

</div>


</template>


<script type="text/javascript">

import TablesList from './TableList.vue'
import TopBar from './TopBar.vue'
import QueryTab from './QueryTab.vue'

export default {
	components: {
		'tables-list': TablesList,
		'top-bar': TopBar,
		'tab': QueryTab
	}
}

</script>
